<template>
  <div class="w-full h2hRow h-[38px] px-2.5 py-[5px] bg-zt-light-full border-y font-medium border-zt-light text-xs gap-3 items-center" :class="{ 'py-[9px] !grid-cols-[21px_1fr_20px_70px_70px]' : !showH2hButton }">
      <div class="uppercase">L.p</div>
      <div class="-ml-3 truncate uppercase">{{ getTitleString(groupName) }}</div>
      <div class="text-center">PKT</div>
      <div class="text-center">DOM</div>
      <div class="text-center">WYJAZD</div>
    </div>
    <div class="h2hRow gap-3 h-[38px] px-2.5 py-[5px] items-center border-b border-zt-light text-[13px] last:border-b-[0px]"
         :class="[team.id === teamId ? 'bg-zt-more/35' : '', { '!grid-cols-[21px_1fr_20px_70px_70px]' : !showH2hButton, '!h-[28px] !min-h-[28px] !py-0' : view === 'compact' && playedMatchesWithTeamCount <= 2,
         'min-h-[69px]' : playedMatchesWithTeamCount > 2 && view === 'normal', 'min-h-[53px]' : playedMatchesWithTeamCount > 2 && view === 'compact'  }, playedMatchesWithTeamCount > 2 ? '' : 'min-h-[36px]']"
         v-for="team of teams" :key="team.team_id">
      <div class="font-['Lato']">{{ team.position }}.</div>
      <div class="-ml-3" :class="{ 'flex' : showCrest }">
        <div v-if="showCrest" class="flex items-center mr-[5px] -translate-y-px aspect-square h-5">
          <TeamImg :key="team.id" field="team_query_name" :team="team"/>
        </div>
        <div class="text-ellipsis break-all line-clamp-1">
          <a v-if="team.id != teamId" class="no-default-style zt-hover" :href="`/wyniki-pilka-nozna/druzyny/${team.team_query_name}/`">{{ team.shortname?.length > 0 ? team.shortname : team.name }}</a>
          <span v-else>{{ team.shortname?.length > 0 ? team.shortname : team.name }}</span>
        </div>
      </div>
      <Transition appear mode="out-in" name="fade-slow">
	      <div :key="filtersKey" class="flex justify-center font-['Lato']">{{ team.points }}</div>
      </Transition>
	    <Transition appear mode="out-in" name="fade-slow">
	      <div :key="filtersKey" class="flex flex-col gap-y-1 text-[13px] font-['Lato']">
	        <div v-if="team.id != teamId && team.homeMatch.length !== 0" v-for="(match, index) of team.homeMatch"
	           :key="index" data-count-click="Kolorowa ➝ kliki w wyniki i daty"
	           :data-href="currentTeam && team && ![2,3,848].includes(CurrentLeagueId) ? `/wyniki-pilka-nozna/porownanie-druzyn/${currentTeam.team_query_name}/${team.team_query_name}/` : null"
	           class="cursor-pointer underline no-default-style rounded-zt xl:no-underline"
	           :class="[{ 'pointer-events-none opacity-35': team.id === teamId }, match.status === 'FT' ? ' zt-hover' : ' hover:bg-zt-light',
	            {'pointer-events-none !no-underline' : [2,3,848].includes(CurrentLeagueId)}]">
	          <div v-if="match.status === 'FT'"
                 :class="{ '!h-5' : shouldBoxBeSmaller }"
                 class="px-3.5 h-[25px] rounded-zt self-stretch flex items-center justify-center whitespace-nowrap
                        duration-300 transition-colors"
                 :style="{ backgroundColor: setH2hBg(match, true) }">
	            <div v-if="(selectedFilters[0] === 'table' || selectedFilters[0] === 'overunder' || selectedFilters[0] === 'btts')">{{ match.localteam_goals }}:{{ match.visitorteam_goals }}</div>
	            <div v-else-if="selectedFilters[0] === 'corners'">{{ match.localteam_corners }}:{{ match.visitorteam_corners }}</div>
	            <div v-else-if="selectedFilters[0] === 'cards' && selectedFilters[1] === 'yellow'">{{ match.localteam_yellowcards }}:{{ match.visitorteam_yellowcards }}</div>
	            <div v-else-if="selectedFilters[0] === 'cards'&& selectedFilters[1] === 'red'">{{ match.localteam_redcards }}:{{ match.visitorteam_redcards }}</div>
	            <div v-else-if="selectedFilters[0] === 'halfs' && selectedFilters[1] === 'firsthalf' ">{{ match.localteam_ht_goals }}:{{ match.visitorteam_ht_goals }}</div>
	            <div v-else-if="selectedFilters[0] === 'halfs' && selectedFilters[1] === 'secondhalf' ">{{ match.localteam_goals - match.localteam_ht_goals }}:{{ match.visitorteam_goals - match.visitorteam_ht_goals }}</div>
	            <div v-else-if="selectedFilters[0] === 'odds'">{{ match.odds ? formatOddsValue(match.odds) : 'B.d.' }}</div>
	            <div v-else-if="selectedFilters[0] === 'cleansheet'">{{ match.localteam_goals }}:{{ match.visitorteam_goals }}</div>
	            <div v-else-if="selectedFilters[0] === 'possesion'">{{ match.localteam_ball_possesion.replace('%', '') }}:{{ match.visitorteam_ball_possesion.replace('%', '') }}</div>
	            <div v-else-if="selectedFilters[0] === 'shots'">{{ match.localteam_shotsongoal }}:{{ match.visitorteam_shotsongoal }}</div>
	            <div v-else-if="selectedFilters[0] === 'offsides'">{{ match.localteam_offsides }}:{{ match.visitorteam_offsides }}</div>
	            <div v-else-if="selectedFilters[0] === 'fouls'">{{ match.localteam_fouls }}:{{ match.visitorteam_fouls }}</div>
	            <div v-else-if="selectedFilters[0] === 'passes'">{{ match.localteam_passaccurate }}:{{ match.visitorteam_passaccurate }}</div>
	            <div v-else class="text-zt-more">-</div>
	          </div>
	          <div v-else class="px-2.5 h-[25px] rounded-zt uppercase self-stretch flex items-center justify-center border
	                           border-zt-light text-zt-more !text-xs"
	                      :class="{'!border-white !text-white font-medium' : match.isNextMatch, '!h-5' : shouldBoxBeSmaller}">
	            <div class="underline" :class="{'!no-underline' : [2,3,848].includes(CurrentLeagueId)}">
                {{ match.status === 'PST' ? 'Przeł.' : formatCellDate(match.date) }}
              </div>
	          </div>
            <a v-if="currentTeam && team && ![2,3,848].includes(CurrentLeagueId)" class="hidden"
               :href="`/wyniki-pilka-nozna/porownanie-druzyn/${currentTeam.team_query_name}/${team.team_query_name}/`">
              {{ currentTeam.shortname?.length > 0 ? currentTeam.shortname : currentTeam.name }} vs {{ team.shortname?.length > 0 ? team.shortname : team.name }}
            </a>
	        </div>
	        <div v-else
               :class="{ '!h-5' : shouldBoxBeSmaller }"
               class="px-3.5 h-[25px] rounded-zt self-stretch flex items-center justify-center border border-zt-light text-zt-more">
	          <div>-</div>
	        </div>
	      </div>
	    </Transition>
	    <Transition appear mode="out-in" name="fade-slow">
	      <div :key="filtersKey" class="flex flex-col gap-y-1 text-[13px] font-['Lato']">
	        <div v-if="team.id != teamId && team.visitorMatch.length !== 0" v-for="(match, index) of team.visitorMatch"
	           :key="index" data-count-click="Kolorowa ➝ kliki w wyniki i daty"
	           :data-href="currentTeam && team && ![2,3,848].includes(CurrentLeagueId) ? `/wyniki-pilka-nozna/porownanie-druzyn/${team.team_query_name}/${currentTeam.team_query_name}/` : null"
	           class="cursor-pointer underline no-default-style rounded-zt xl:no-underline"
	           :class="[{ 'pointer-events-none opacity-35': team.id === teamId }, match.status === 'FT' ? ' zt-hover' : ' hover:bg-zt-light',
	            {'pointer-events-none !no-underline' : [2,3,848].includes(CurrentLeagueId)}]">
	          <div v-if="match.status === 'FT'"
                 :class="{ '!h-5' : shouldBoxBeSmaller }"
                 class="px-3.5 h-[25px] rounded-zt self-stretch flex items-center justify-center whitespace-nowrap
                        transition-colors duration-300" :style="{ backgroundColor: setH2hBg(match, false) }">
	            <div v-if="(selectedFilters[0] === 'table' || selectedFilters[0] === 'overunder' || selectedFilters[0] === 'btts')">{{ match.localteam_goals }}:{{ match.visitorteam_goals }}</div>
	            <div v-else-if="selectedFilters[0] === 'corners'">{{ match.localteam_corners }}:{{ match.visitorteam_corners }}</div>
	            <div v-else-if="selectedFilters[0] === 'cards' && selectedFilters[1] === 'yellow'">{{ match.localteam_yellowcards }}:{{ match.visitorteam_yellowcards }}</div>
	            <div v-else-if="selectedFilters[0] === 'cards' && selectedFilters[1] === 'red'">{{ match.localteam_redcards }}:{{ match.visitorteam_redcards }}</div>
	            <div v-else-if="selectedFilters[0] === 'halfs' && selectedFilters[1] === 'firsthalf'">{{ match.localteam_ht_goals }}:{{ match.visitorteam_ht_goals }}</div>
	            <div v-else-if="selectedFilters[0] === 'halfs' && selectedFilters[1] === 'secondhalf'">{{ match.localteam_goals - match.localteam_ht_goals }}:{{ match.visitorteam_goals - match.visitorteam_ht_goals }}</div>
	            <div v-else-if="selectedFilters[0] === 'odds'">{{ match.odds ? formatOddsValue(match.odds) : 'B.d.' }}</div>
	            <div v-else-if="selectedFilters[0] === 'cleansheet'">{{ match.localteam_goals }}:{{ match.visitorteam_goals }}</div>
	            <div v-else-if="selectedFilters[0] === 'possesion'">{{ match.localteam_ball_possesion.replace('%', '') }}:{{ match.visitorteam_ball_possesion.replace('%', '') }}</div>
	            <div v-else-if="selectedFilters[0] === 'shots'">{{ match.localteam_shotsongoal }}:{{ match.visitorteam_shotsongoal }}</div>
	            <div v-else-if="selectedFilters[0] === 'offsides'">{{ match.localteam_offsides }}:{{ match.visitorteam_offsides }}</div>
	            <div v-else-if="selectedFilters[0] === 'fouls'">{{ match.localteam_fouls }}:{{ match.visitorteam_fouls }}</div>
	            <div v-else-if="selectedFilters[0] === 'passes'">{{ match.localteam_passaccurate }}:{{ match.visitorteam_passaccurate }}</div>
	            <div @click="countClicks('Kolorowa ➝ kliki w wyniki i daty')" v-else class="text-zt-more">-</div>
	          </div>
	          <div v-else class="px-3 h-[25px] rounded-zt uppercase self-stretch flex items-center justify-center border
	                           border-zt-light text-zt-more !text-xs whitespace-nowrap"
	                      :class="{'!border-white !text-white font-medium' : match.isNextMatch, '!h-5' : shouldBoxBeSmaller}">
	            <div class="underline" :class="{'!no-underline' : [2,3,848].includes(CurrentLeagueId)}">
                {{ match.status === 'PST' ? 'Przeł.' : formatCellDate(match.date) }}
              </div>
	          </div>
            <a v-if="currentTeam && team && ![2,3,848].includes(CurrentLeagueId)" class="hidden"
               :href="`/wyniki-pilka-nozna/porownanie-druzyn/${team.team_query_name}/${currentTeam.team_query_name}/`">
              {{ team.shortname?.length > 0 ? team.shortname : team.name }} vs {{ currentTeam.shortname?.length > 0 ? currentTeam.shortname : currentTeam.name }}
            </a>
	        </div>
	        <div v-else
               :class="{ '!h-5' : shouldBoxBeSmaller }"
               class="px-3.5 h-[25px] rounded-zt self-stretch flex items-center justify-center border border-zt-light text-zt-more">
	          <div>-</div>
	        </div>
	      </div>
	    </Transition>
<!--      <a v-if="showH2hButton" :data-count-click="analyticText"-->
<!--         :href="`/wyniki-pilka-nozna/porownanie-druzyn/${currentTeam?.team_query_name}/${team?.team_query_name}/`"-->
<!--         class="cursor-pointer no-default-style zt-hover"-->
<!--         :class="{ 'pointer-events-none opacity-35': team.id === teamId }">-->
<!--        <svg width="25" height="19" viewBox="0 0 25 19" fill="none" xmlns="http://www.w3.org/2000/svg">-->
<!--          <rect width="25" height="19" rx="3" fill="#B3B3B3" fill-opacity="0.75"/>-->
<!--          <path d="M7.58527 7.36C8.13194 7.36 8.56194 7.51667 8.87527 7.83C9.19527 8.14333 9.35527 8.58 9.35527 9.14C9.35527 9.32667 9.33527 9.52667 9.29527 9.74L8.71527 13H7.01527L7.55527 9.97C7.57527 9.85667 7.58527 9.75667 7.58527 9.67C7.58527 9.39 7.50527 9.17333 7.34527 9.02C7.19194 8.86667 6.97527 8.79 6.69527 8.79C6.36194 8.79 6.08194 8.89333 5.85527 9.1C5.62861 9.30667 5.48194 9.59667 5.41527 9.97V9.95L4.87527 13H3.16527L4.47527 5.6H6.18527L5.73527 8.16C5.95527 7.91333 6.22527 7.72 6.54527 7.58C6.86527 7.43333 7.21194 7.36 7.58527 7.36ZM10.1536 11.35C10.8802 10.83 11.4602 10.4 11.8936 10.06C12.3269 9.72 12.7002 9.37333 13.0136 9.02C13.3336 8.66 13.5202 8.31667 13.5736 7.99C13.5936 7.89667 13.6036 7.81 13.6036 7.73C13.6036 7.53667 13.5502 7.39 13.4436 7.29C13.3436 7.19 13.1902 7.14 12.9836 7.14C12.4702 7.14 12.1436 7.50333 12.0036 8.23H10.3436C10.5169 7.39 10.8769 6.76 11.4236 6.34C11.9769 5.91333 12.6102 5.7 13.3236 5.7C14.0169 5.7 14.5302 5.85667 14.8636 6.17C15.2036 6.48333 15.3736 6.89667 15.3736 7.41C15.3736 7.57 15.3602 7.71667 15.3336 7.85C15.2136 8.53 14.8602 9.16333 14.2736 9.75C13.6936 10.3367 12.9736 10.9233 12.1136 11.51H14.8136L14.5636 12.9H9.54355L9.76355 11.63L10.1536 11.35ZM19.7364 7.36C20.2831 7.36 20.7131 7.51667 21.0264 7.83C21.3464 8.14333 21.5064 8.58 21.5064 9.14C21.5064 9.32667 21.4864 9.52667 21.4464 9.74L20.8664 13H19.1664L19.7064 9.97C19.7264 9.85667 19.7364 9.75667 19.7364 9.67C19.7364 9.39 19.6564 9.17333 19.4964 9.02C19.3431 8.86667 19.1264 8.79 18.8464 8.79C18.5131 8.79 18.2331 8.89333 18.0064 9.1C17.7798 9.30667 17.6331 9.59667 17.5664 9.97V9.95L17.0264 13H15.3164L16.6264 5.6H18.3364L17.8864 8.16C18.1064 7.91333 18.3764 7.72 18.6964 7.58C19.0164 7.43333 19.3631 7.36 19.7364 7.36Z" fill="#3A4B64"/>-->
<!--        </svg>-->
<!--      </a>-->
  </div>
</template>

<script>
import utils_mixin from "../../../mixins/utils_mixin";
import football_mixin from "../../../mixins/football_mixin";
import TeamImg from "../blocks/TeamImg.vue";

export default {
  name: "H2hMainTable",
  components: {TeamImg},
	mixins: [utils_mixin, football_mixin],
  props: {
    teams: Array,
    teamId: Number,
    selectedFilters: Array,
    group: {
      type: String,
      default: ''
    },
	  analyticType: {
		  type: String,
		  default: ''
	  },
	  showH2hButton: {
			type: Boolean,
		  default: true
	  },
    showCrest: {
      type: Boolean,
      default: true
    },
    leagueId: {
      type: Number,
      default: null
    },
    view: {
      type: String,
      default: 'normal',
      validator: function (value) {
        return ['normal', 'compact'].includes(value);
      }
    }
  },
	computed: {
    shouldBoxBeSmaller() {
      return this.view === 'compact';
    },
		filtersKey() {
			return this.selectedFilters.join('-')+this.view;
		},
		analyticText() {
			if (this.analyticType === 'league-h2h-overview') {
				return 'LIGA - PRZEGLĄD - Przycisk H2H';
			}
			if (this.analyticType === 'team-h2h-overview') {
				return 'DRUŻYNA - Przycisk H2H';
			}
		},
		currentTeam() {
			return this.teams.find(team => team.id === this.teamId);
		},
    playedMatchesWithTeamCount() {
      let filteredTeams = this.teams.filter((team) => {
        return team.id !== this.teamId;
      });
      return Math.max(...filteredTeams.map(team => (team.homeMatch.length > 1 || team.visitorMatch.length > 1) ? 3 : team.homeMatch.length + team.visitorMatch.length ));
    },
    groupName() {
      return this.group;
    },
    CurrentLeagueId() {
      return this.leagueId
    }
	},
  updated() {
    this.$nextTick(initializeClickableElements);
  },
  methods: {
		formatCellDate(date) {
			date = DateTime.fromSQL(date);
      if (date.hasSame(DateTime.now(), 'day')) {
        return 'dziś';
      }
      if (date.hasSame(DateTime.now().plus({ days: 1 }), 'day')) {
        return 'jutro';
      }
			return date.toFormat('d LLL');
		},
	  formatOddsValue(value) {
		  value = parseFloat(value);
		  if (value >= 1000) {
			  return '999+';
		  }
		  if (value < 10) {
			  return value.toFixed(2)
		  }
		  if (value >= 10) {
			  return value.toFixed(1);
		  }
			return '-';
	  },
    setH2hBg( match, isHomeMatch ) {
      const green = '#32AB29';
      const red = '#CE2121';
      const yellow = '#B79200';
      if ( this.selectedFilters[0] === 'table' || this.selectedFilters[0] === 'odds' ) {
        if (this.selectedFilters[1] === '1x2' || this.selectedFilters[0] === 'table') {
          if ( isHomeMatch ? +match.localteam_goals > +match.visitorteam_goals : +match.visitorteam_goals > +match.localteam_goals ) {
            return green;
          } else if ( isHomeMatch ? +match.localteam_goals < +match.visitorteam_goals : +match.visitorteam_goals < +match.localteam_goals ) {
            return red;
          } else {
            return yellow;
          }
        } else {
          if ( isHomeMatch ? +match.localteam_goals > +match.visitorteam_goals : +match.visitorteam_goals > +match.localteam_goals ) {
            return green;
          } else {
            return red;
          }
        }
      } else if ( this.selectedFilters[0] === 'overunder' ) {
        if ( +match.localteam_goals + +match.visitorteam_goals > this.selectedFilters[1] ) {
          return green;
        } else {
          return red;
        }
      } else if ( this.selectedFilters[0] === 'btts' ) {
        if ( +match.localteam_goals > 0 && +match.visitorteam_goals > 0 ) {
          return green;
        } else {
          return red;
        }
      } else if ( this.selectedFilters[0] === 'corners' ) {
        if ( this.selectedFilters[1] !== 'overunder' ) {
          if ( isHomeMatch ? +match.localteam_corners > +match.visitorteam_corners : +match.visitorteam_corners > +match.localteam_corners ) {
            return green;
          } else if ( isHomeMatch ? +match.localteam_corners < +match.visitorteam_corners : +match.visitorteam_corners < +match.localteam_corners ) {
            return red;
          } else {
            return yellow;
          }
        } else {
          if ( +match.localteam_corners + +match.visitorteam_corners > this.selectedFilters[2] ) {
            return green;
          } else if ( +match.localteam_corners + +match.visitorteam_corners < this.selectedFilters[2] ) {
            return red;
          } else {
            return yellow;
          }
        }
      } else if ( this.selectedFilters[0] === 'cards' ) {
        if (this.selectedFilters[1] === 'yellow') {
          if ( this.selectedFilters[2] !== 'overunder' ) {
            if ( isHomeMatch ? +match.localteam_yellowcards > +match.visitorteam_yellowcards : +match.visitorteam_yellowcards > +match.localteam_yellowcards ) {
              return green;
            } else if ( isHomeMatch ? +match.localteam_yellowcards < +match.visitorteam_yellowcards : +match.visitorteam_yellowcards < +match.localteam_yellowcards ) {
              return red;
            } else {
              return yellow;
            }
          } else {
            if ( +match.localteam_yellowcards + +match.visitorteam_yellowcards > this.selectedFilters[3] ) {
              return green;
            } else if ( +match.localteam_yellowcards + +match.visitorteam_yellowcards < this.selectedFilters[3] ) {
              return red;
            } else {
              return yellow;
            }
          }
        } else {
          if ( this.selectedFilters[2] !== 'overunder' ) {
            if ( isHomeMatch ? +match.localteam_redcards > +match.visitorteam_redcards : +match.visitorteam_redcards > +match.localteam_redcards ) {
              return green;
            } else if ( isHomeMatch ? +match.localteam_redcards < +match.visitorteam_redcards : +match.visitorteam_redcards < +match.localteam_redcards ) {
              return red;
            } else {
              return yellow;
            }
          } else {
            if ( +match.localteam_redcards + +match.visitorteam_redcards > this.selectedFilters[3] ) {
              return green;
            } else if ( +match.localteam_redcards + +match.visitorteam_redcards < this.selectedFilters[3] ) {
              return red;
            } else {
              return yellow;
            }
          }
        }
      } else if ( this.selectedFilters[0] === 'halfs' ) {
        if ( this.selectedFilters[1] === 'firsthalf' ) {
          if ( isHomeMatch ? +match.localteam_ht_goals > +match.visitorteam_ht_goals : +match.visitorteam_ht_goals > +match.localteam_ht_goals ) {
            return green;
          } else if ( isHomeMatch ? +match.localteam_ht_goals < +match.visitorteam_ht_goals : +match.visitorteam_ht_goals < +match.localteam_ht_goals ) {
            return red;
          } else {
            return yellow;
          }
        } else {
          let locTeamSecondHalfGoals = +match.localteam_goals - +match.localteam_ht_goals;
          let visTeamSecondHalfGoals = +match.visitorteam_goals - +match.visitorteam_ht_goals;

          if ( isHomeMatch ? locTeamSecondHalfGoals > visTeamSecondHalfGoals : visTeamSecondHalfGoals > locTeamSecondHalfGoals ) {
          return green;
          } else if ( isHomeMatch ? locTeamSecondHalfGoals < visTeamSecondHalfGoals : visTeamSecondHalfGoals < locTeamSecondHalfGoals ) {
            return red;
          } else {
            return yellow;
          }
        }
      } else if ( this.selectedFilters[0] === 'cleansheet' ) {
        if ( isHomeMatch ? 0 < +match.visitorteam_goals : 0 < +match.localteam_goals ) {
          return red;
        } else {
          return green;
        }
      }
      else if ( this.selectedFilters[0] === 'possesion' ) {
        if ( isHomeMatch ? Number(match.localteam_ball_possesion.replace('%','')) > Number(match.visitorteam_ball_possesion.replace('%','')) :
            Number(match.visitorteam_ball_possesion.replace('%','')) > Number(match.localteam_ball_possesion.replace('%',''))) {
          return green;
        } else if (isHomeMatch ? Number(match.localteam_ball_possesion.replace('%','')) < Number(match.visitorteam_ball_possesion.replace('%','')) :
            Number(match.visitorteam_ball_possesion.replace('%','')) < Number(match.localteam_ball_possesion.replace('%',''))) {
          return red;
        } else {
          return yellow;
        }
      }
      else if ( this.selectedFilters[0] === 'offsides' ) {
        if ( this.selectedFilters[1] !== 'overunder' ) {
          if ( isHomeMatch ? +match.localteam_offsides > +match.visitorteam_offsides :
              +match.visitorteam_offsides > +match.localteam_offsides ) {
            return green;
          } else if (isHomeMatch ? +match.localteam_offsides < +match.visitorteam_offsides :
              +match.visitorteam_offsides < +match.localteam_offsides) {
            return red;
          } else {
            return yellow;
          }
        } else {
          if ( +match.localteam_offsides + +match.visitorteam_offsides > this.selectedFilters[2] ) {
            return green;
          } else if ( +match.localteam_offsides + +match.visitorteam_offsides < this.selectedFilters[2] ) {
            return red;
          } else {
            return yellow;
          }
        }
      }
      else if ( this.selectedFilters[0] === 'shots' ) {
        if ( isHomeMatch ? +match.localteam_shotsongoal > +match.visitorteam_shotsongoal :
            +match.visitorteam_shotsongoal > +match.localteam_shotsongoal ) {
          return green;
        } else if (isHomeMatch ? +match.localteam_shotsongoal < +match.visitorteam_shotsongoal :
            +match.visitorteam_shotsongoal < +match.localteam_shotsongoal) {
          return red;
        } else {
          return yellow;
        }
      }
      else if ( this.selectedFilters[0] === 'fouls' ) {
        if ( isHomeMatch ? +match.localteam_fouls > +match.visitorteam_fouls :
            +match.visitorteam_fouls > +match.localteam_fouls ) {
          return green;
        } else if (isHomeMatch ? +match.localteam_fouls < +match.visitorteam_fouls :
            +match.visitorteam_fouls < +match.localteam_fouls) {
          return red;
        } else {
          return yellow;
        }
      }
      else if ( this.selectedFilters[0] === 'passes' ) {
        if ( isHomeMatch ? +match.localteam_passaccurate > +match.visitorteam_passaccurate :
            +match.visitorteam_passaccurate > +match.localteam_passaccurate ) {
          return green;
        } else if (isHomeMatch ? +match.localteam_passaccurate < +match.visitorteam_passaccurate :
            +match.visitorteam_passaccurate < +match.localteam_passaccurate) {
          return red;
        } else {
          return yellow;
        }
      }
    },
  },
}
</script>

<style scoped>
  .h2hRow {
    display: grid;
    grid-template-columns: 21px 1fr 20px 70px 70px;
  }

  .fade-enter-active,
  .fade-leave-active {
    z-index: 10;
    transition: all 0.15s ease-out;
  }

  .fade-enter-from,
  .fade-leave-to {
    z-index: 10;
    opacity: 0;
  }
  .fade-slow-enter-active,
  .fade-slow-leave-active {
	  z-index: 10;
	  transition: all 0.3s ease-out;
  }

  .fade-slow-enter-from,
  .fade-slow-leave-to {
	  z-index: 10;
	  opacity: 0;
  }
</style>